import coreModule from '../core_module';

export class HomeCtrl {
  hasLoaded = false;
  hasExperiments: boolean;
  matlabPluginUrl: string;

  /** @ngInject */
  constructor(matlabPluginSrv, experimentSrv) {
    matlabPluginSrv.getUrl().then(url => {
      this.matlabPluginUrl = url;
    });

    experimentSrv.getRootObjectCount().then(count => {
      this.hasLoaded = true;
      this.hasExperiments = count > 0;
    });
  }
}

coreModule.controller('HomeCtrl', HomeCtrl);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/core/controllers/home_ctrl.ts